// Historique PERSISTÉ des chats scénarisés — CCT-97.
//
// L'état de chat vivait uniquement en mémoire (ChatStateContext) : au rechargement, les
// répliques du JOUEUR disparaissaient et le centre de messagerie n'affichait plus qu'un
// monologue du personnage. La base (assignment.chatstatejson) est désormais la référence.
import { apiFetch } from './client';

export interface PersistedChatMsg {
  role: 'character' | 'student';
  text: string;
  characterName?: string;
}

/** Tous les fils scénarisés déjà joués de la mission, indexés par id d'élément. */
export const getStoryChatState = (token: string | null, missionId: number) =>
  apiFetch<{ missionId: number; chats: Record<string, PersistedChatMsg[]> }>(
    `/me/stories/${missionId}/chat-state`, { token, auth: true });

/** Remplace le fil de CET élément (on envoie l'échange complet, pas un delta). */
export const saveStoryChatState = (
  token: string | null, missionId: number, itemId: string | number, messages: PersistedChatMsg[],
) =>
  apiFetch<{ count: number }>(
    `/me/stories/${missionId}/items/${encodeURIComponent(String(itemId))}/chat-state`,
    { token, auth: true, method: 'PUT', body: { messages } });
